import Vue from 'vue';

Vue.component('popup-component', {
    props: {
        content: {
            type: Object,
            default: () => { },
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            popupOpen: false,
            popupTitle: null,
            popupText: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('popup-content', (sliderId, slideId) => {
            if (!sliderId) {
                return;
            }

            this.popupOpen = true;
            this.popupTitle = this.content[sliderId][slideId].title;
            this.popupText = this.content[sliderId][slideId].text;
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        closePopup() {
            this.popupOpen = false;
            this.popupTitle = null;
            this.popupText = null;
        },
    },
});
